var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentLibDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5625 6.625H9.625V6.4375C9.625 6.12684 9.37316 5.875 9.0625 5.875H7.9375C7.62684 5.875 7.375 6.12684 7.375 6.4375V6.625H6.4375C6.33395 6.625 6.25 6.70895 6.25 6.8125C6.25 6.91605 6.33395 7 6.4375 7H6.625V10.375C6.625 10.5821 6.79289 10.75 7 10.75H10C10.2071 10.75 10.375 10.5821 10.375 10.375V7H10.5625C10.6661 7 10.75 6.91605 10.75 6.8125C10.75 6.70895 10.6661 6.625 10.5625 6.625ZM7.75 6.4375C7.75 6.33395 7.83395 6.25 7.9375 6.25H9.0625C9.16605 6.25 9.25 6.33395 9.25 6.4375V6.625H7.75V6.4375ZM10 10.375H7V7H10V10.375ZM8.125 7.9375V9.4375C8.125 9.54105 8.04105 9.625 7.9375 9.625C7.83395 9.625 7.75 9.54105 7.75 9.4375V7.9375C7.75 7.83395 7.83395 7.75 7.9375 7.75C8.04105 7.75 8.125 7.83395 8.125 7.9375ZM9.25 7.9375V9.4375C9.25 9.54105 9.16605 9.625 9.0625 9.625C8.95895 9.625 8.875 9.54105 8.875 9.4375V7.9375C8.875 7.83395 8.95895 7.75 9.0625 7.75C9.16605 7.75 9.25 7.83395 9.25 7.9375Z",
    fill: "#140D1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLibDeleteIcon);
export default __webpack_public_path__ + "static/media/ContentLib_Delete_Icon.9a2b7ecfe94eccbdcc474a8fae872dfd.svg";
export { ForwardRef as ReactComponent };